

































































































































































import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import { mapActions } from 'vuex'

import AuthorizationMixin from '@/routing/AuthorizationMixin'
import CaseChooser from '@/components/layout/CaseChooser.vue'
import { RunningProcess } from '@/store/workflow/types'
import { AxiosInstance } from 'axios'

import { CaseListWithMessageCounts } from '@/queries/cases.graphql'
import { CaseListWithMessageCountsQuery } from '@/graphql-schema'

export interface Data {
  cases: CaseListWithMessageCountsQuery['cases']
  showSignInModal: boolean
  loginFailed: boolean
  signInForm: {
    login: string
    password: string
  }
}

export default mixins(AuthorizationMixin).extend({
  apollo: {
    /*cases: {
      query: CaseListWithMessageCounts,
      fetchPolicy: 'cache-and-network',
      pollInterval: 60000,
    },*/
  },
  components: {
    CaseChooser,
  },
  computed: {
    numberOfNewMessages(): number {
      /*return (
        this.cases?.nodes.reduce((newMessages, chat) => {
          return newMessages + (parseInt(chat.newMessages) || 0)
        }, 0) || 0
      )*/
      const messages = this.$store.getters['myMessages/storedObjectsArray']
      return (
        messages?.reduce((newMessages, message) => {
          return newMessages + (parseInt(message.messagecount, 10) || 0)
        }, 0) || 0
      )
    },
    caseId(): string | null {
      return this.$store.getters.currentCaseId
    },
    caseDiagnosis(): string | null {
      return this.$store.getters.currentCase!.diagnosis
    },
    isSignedIn(): boolean {
      return this.$store.getters.isSignedIn
    },
    currentUser(): any {
      return this.$store.getters.currentUser
    },
    numberOfCases(): number {
      return this.$store.getters.numberOfCases
    },
    currentTrial(): RunningProcess | undefined {
      return this.$store.getters['workflow/currentTrial']
    },
  },
  data(): Data {
    return {
      cases: { nodes: [] },
      showSignInModal: false,
      loginFailed: false,
      signInForm: {
        login: '',
        password: '',
      },
    }
  },
  methods: {
    ...mapActions('workflow', ['fetch', 'startProcess']),
    async dropoutMessage() {
      const trial: RunningProcess | undefined = this.currentTrial
      if (!trial) {
        return
      }
      const http: AxiosInstance = this.$store.getters.http
      await http.post(`/api/workflow/rest/process-instance/${trial.id}/modification`, {
        skipCustomListeners: true,
        skipIoMappings: true,
        instructions: [
          {
            type: 'startBeforeActivity',
            activityId: 'overall-reminder2',
          },
        ],
      })
      window.alert('ok, therapist should see a new task.')
    },
    async dropoutCall() {
      const trial: RunningProcess | undefined = this.currentTrial
      if (!trial) {
        return
      }
      const http: AxiosInstance = this.$store.getters.http
      await http.post(`/api/workflow/rest/process-instance/${trial.id}/modification`, {
        skipCustomListeners: true,
        skipIoMappings: true,
        instructions: [
          {
            type: 'startBeforeActivity',
            activityId: 'call-patient',
          },
        ],
      })
      window.alert('ok, therapist should see a new task.')
    },
    async finalDropoutDecision() {
      const trial: RunningProcess | undefined = this.currentTrial
      if (!trial) {
        return
      }
      const http: AxiosInstance = this.$store.getters.http
      await http.post(`/api/workflow/rest/process-instance/${trial.id}/modification`, {
        skipCustomListeners: true,
        skipIoMappings: true,
        instructions: [
          {
            type: 'startBeforeActivity',
            activityId: 'sight-case-and-decide-on-dropout',
          },
        ],
      })
      window.alert('ok, therapist should see a new task.')
    },
    async refresh() {
      await this.$store.dispatch({ type: 'workflow/reset' })
      await this.$store.dispatch({ type: 'workflow/fetch' })
    },
    async dropout() {
      if (window.confirm('sure to dropout this patient?')) {
        return await this.$store.dispatch({
          type: 'workflow/sendSignal',
          name: `patient.dropped-out-from-case-${this.caseId}`,
        })
      }
    },
    logout() {
      this.$store.dispatch({ type: 'logout' })
    },
    resetSignInForm() {
      this.signInForm = {
        login: '',
        password: '',
      }
    },
    wrapDate(date: Date | undefined): { type: 'String'; value: string } {
      date = date || new Date()
      return { type: 'String', value: date.toISOString() } //.substring(0, 19) }
    },
    confirm(message: string = 'Are you sure?'): boolean {
      return window.confirm(message)
    },
    signIn() {
      this.loginFailed = false
      this.$store
        .dispatch({
          credentials: this.signInForm,
          type: 'LOGIN',
        })
        .then(() => {
          this.loginFailed = false
          this.showSignInModal = false
        })
        .catch(reason => {
          const { error } = reason.response.data
          this.loginFailed = error
        })
    },
  },
})
